import { Auth } from "aws-amplify";
import config from "./config";
import { toast } from "react-toastify";

const endpointUrl = (url: string) => {
	return `${config.API_URL}${url}`;
};

const logRequest = (method: string, url: string, headers: any, body: any) => {
	console.log("\n");
	console.log(`${method}: ${endpointUrl(url)}`);

	for (const [key, value] of Object.entries(headers)) {
		console.log(`${key}: ${value}`);
	}
	console.log("\n");
	if (body) {
		console.log(body);
	}

	console.log("----------------------------------------");
};

function logResponse(statusCode: number, url: string, headers: any, body: any) {
	console.log("\n");
	console.log(`${statusCode.toString()}: ${endpointUrl(url)}`);

	for (const [key, value] of Object.entries(headers)) {
		console.log(`${key}: ${value}`);
	}
	console.log("\n");
	if (body) {
		console.log(body);
	}

	console.log("----------------------------------------");
}

const request = async (
	method: string,
	url: string,
	data: any,
	withAuth = true,
	handleErrors = true,
	rawData = false
) => {
	let authHeader = {};
	if (withAuth) {
		let creds = (await Auth.currentSession()) as any;
		if (config.LOG_REQUESTS) {
			console.log(creds);
		}

		authHeader = { Authorization: `Bearer ${creds.idToken.jwtToken}` };
	}

	const headers = {
		...authHeader,
		...(rawData
			? {}
			: {
					Accept: "application/json",
					"Content-Type": "application/json; charset=utf-8",
			  }),
	};

	let body = undefined;
	if (data) {
		if (!rawData) {
			body = JSON.stringify(data);
		} else {
			body = data;
		}
	}

	if (config.LOG_REQUESTS) {
		logRequest(method, url, headers, body);
	}

	const res = await fetch(endpointUrl(url), {
		headers: headers,
		method: method,
		body: body,
		credentials: "include",
	});

	if (res.ok) {
		const text = await res.text();

		if (config.LOG_REQUESTS) {
			logResponse(res.status, url, res.headers, text);
		}
		const obj = JSON.parse(text);

		return { success: obj.success, message: obj.message, data: obj };
	} else if (!handleErrors) {
		return { success: false, res: res };
	} else {
		if (res.status === 401 || res.status === 403) {
			handleError("You do not have permission to perform that action");

			return { success: false };
		} else if (res.status >= 500) {
			handleError("An unknown error occurred (1)");

			return { success: false };
		}
	}

	handleError("An unknown error occurred (2)");
	return { success: false };
};

const handleError = (message: string) => {
	toast.error(message, { position: "bottom-right" });
};

export default request;
